module.exports = __webpack_public_path__ + "img/37_30.735f4620.png";